import axios from "axios";
import api from "./";

export default {
    /**
     * Get activities
     * @param params
     */
    get(params) {
        return api
            .get(`/activities`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Create activity
     * @param data
     */
    create(data) {
        return api.post(`/activities`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Show activity
     * @param activityId
     * @param params
     */
    show(activityId, params) {
        return api
            .get(`/activities/${activityId}`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Update activity
     * @param activityId
     * @param data
     */
    update(activityId, data) {
        return api.put(`/activities/${activityId}`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Delete activity
     * @param activityId
     */
    delete(activityId) {
        return api.delete(`/activities/${activityId}`).then((response) => {
            return response.data;
        });
    },

    /**
     * Show activity by slug
     * @param slug
     * @param params
     */
    showBySlug(slug, params) {
        return api
            .get(`/activities/slug/${slug}`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get partners of an activity
     * @param activityId
     * @param params
     */
    getPartners(activityId, params) {
        return api
            .get(`/activities/${activityId}/partners`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Add media
     * @param activityId
     * @param params
     */
    addMedia(activityId, data) {
        return api
            .post(`/activities/${activityId}/medias`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Add contact
     * @param activityId
     * @param params
     */
    addContact(activityId, data) {
        return api
            .post(`/activities/${activityId}/contacts`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get offers
     * @param activityId
     * @param params
     */
    getOffers(activityId, params) {
        return api
            .get(`/activities/${activityId}/offers`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Create offer
     * @param activityId
     * @param params
     */
    createOffer(activityId, data) {
        return api
            .post(`/activities/${activityId}/offers`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get activities of partner
     * @param partnerId
     * @param params
     */
    getActivitiesOfPartner(partnerId, params) {
        return api
            .get("/activities", {
                params: {
                    ...{ partners: [partnerId] },
                    ...params,
                },
            })
            .then((response) => {
                return response.data;
            });
    },
};
